import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TswpCoreMasterdataModule } from '@trustedshops/tswp-core-masterdata-implementation';
import { TswpCoreUiSharedModule } from '../../common/tswp-core-ui-shared.module';
import { ProductFeatureUpgradeBannerComponent } from './product-feature-upgrade-banner.component';
import { ProductFeatureUpgradeBannerInitializer } from './product-feature-upgrade-banner.bootstrapper';
import { ProductFeatureUpgradeTranslationService } from '../../services/product-feature-upgrade-translation.service';

@NgModule({
  imports: [CommonModule, TswpCoreMasterdataModule, TswpCoreUiSharedModule],
  declarations: [ProductFeatureUpgradeBannerComponent],
  providers: [
    ProductFeatureUpgradeBannerInitializer,
    ProductFeatureUpgradeTranslationService,
  ],
  exports: [ProductFeatureUpgradeBannerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductFeatureUpgradeBannerModule {}
